/* import __COLOCATED_TEMPLATE__ from './section.hbs'; */
import templateOnly from '@ember/component/template-only';
import type { BvModalSectionHeaderSignature } from 'volta/components/bv-modal/section-header';
import type { ComponentLike, ContentValue } from '@glint/template';

export interface BvModalSectionSignature {
  Args: {
    flush?: boolean;
    subdued?: boolean;
    title?: ContentValue;
  };
  Blocks: {
    default: [props?: { Header: ComponentLike<BvModalSectionHeaderSignature> }];
    header: [];
  };
  Element: HTMLDivElement;
}

const BvModalSectionComponent = templateOnly<BvModalSectionSignature>('BvModal::Section');

export default BvModalSectionComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvModal::Section': typeof BvModalSectionComponent;
    'bv-modal/section': typeof BvModalSectionComponent;
  }
}
